import { useEffect, useState } from "react";

function useElementOnScreen(ref, rootMargin = "0px") {
  const [isIntersecting, setIsIntersecting] = useState(false);

  useEffect(() => {
    const currentElement = ref.current;

    // Check if element is already in viewport on mount (important for mobile)
    if (currentElement) {
      const rect = currentElement.getBoundingClientRect();
      const isInView = rect.top < window.innerHeight && rect.bottom > 0;
      if (isInView) {
        setIsIntersecting(true);
      }
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        // Once visible, keep it visible (don't re-animate on scroll back up)
        if (entry.isIntersecting) {
          setIsIntersecting(true);
        }
      },
      {
        rootMargin,
        threshold: 0.1 // Trigger when 10% of element is visible (better for mobile)
      }
    );

    if (currentElement) {
      observer.observe(currentElement);
    }

    return () => {
      if (currentElement) {
        observer.unobserve(currentElement);
      }
    };
  }, [ref, rootMargin]);

  return isIntersecting;
}

export { useElementOnScreen };
